var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVectorArrowUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 10,
    viewBox: "0 0 19 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91496 0.000431061C10.1152 0.000431061 10.3074 0.0819035 10.4492 0.226526L18.7151 8.6812C19.0103 8.98316 19.0103 9.47221 18.7151 9.77353C18.4198 10.0755 17.9418 10.0755 17.647 9.77353L9.91471 1.86455L2.18187 9.77298C1.88662 10.0749 1.40865 10.0749 1.1138 9.77298C0.818958 9.47101 0.818542 8.98219 1.1138 8.68065L9.38076 0.226526C9.52238 0.0816889 9.71458 0 9.91479 0L9.91496 0.000431061Z",
    fill: "#565656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorArrowUp);
export default __webpack_public_path__ + "static/media/vector-arrow-up.8f51720d3b14ee9d130aeb2a8024bfbc.svg";
export { ForwardRef as ReactComponent };